import { render, staticRenderFns } from "./Top10ProjectByRank.vue?vue&type=template&id=39600d88"
import script from "./Top10ProjectByRank.vue?vue&type=script&lang=js"
export * from "./Top10ProjectByRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports